<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center content-wrapper" id="page-login">
    <div class="vx-col w-4/5 md:w-1/2 lg:w-3/4 xl:w-3/5 pt-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
           <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col w-full py-8 px-12 lg:p-0 lg:w-1/2 text-center">
              <img v-if="appName === 'FlipPay'" src="@/assets/images/logo/flippay-logo.svg" width="65%" height="auto" alt="Flippay" class="mx-auto" />
              <img v-else-if="appName === 'Rello'" src="@/assets/images/logo/rello-logo.svg" width="65%" height="auto" alt="Rello" class="mx-auto" />
              <div class="vx-card__title text-center pt-6 lg:hidden">
                  <h3 class="mb-4 text-xl lg:text-2xl">Password reset successfully</h3>
                  <p>Head back to the login page to login with your new password.</p>
                </div>
            </div>
            <div class="vx-col w-full lg:w-1/2">
              <div class="pt-6 pb-10 px-12 lg:pt-10 lg:pb-12 lg:px-10 login-tabs-container bg-white">
                <div class="vx-card__title mb-12 lg:mb-0 lg:mb-4 text-center lg:text-left hidden lg:block">
                  <h3 class="mb-4 text-xl lg:text-2xl text-center">Password reset successfully</h3>
                  <p>Head back to the login page to login with your new password.</p>
                </div>
               <div class="flex flex-col">
                <vs-button to="/login" size="large" class="round w-full mb-0 mt-8" v-round>Back To Login</vs-button>
               </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_NAME ||"FlipPay"
    }
  }
}

</script>

